'use client'
import { ForwardedRef, useEffect, useRef } from "react";

export function useForwardedRef<T>(ref: ForwardedRef<T>) {
	const innerRef = useRef<T>(null);

	// This useEffect runs after every render to update the forwarded ref in sync with the inner ref that needs to be assignd to the component.
	// It needs to be in a useEffect because the ref value is not available until after the render is complete.
	useEffect(() => {
		if (!ref) return;
		if (typeof ref === "function") {
			ref(innerRef.current);
		} else {
			ref.current = innerRef.current;
		}
	});

	return innerRef;
}
